import { PushNotificationRecord } from "../models/PushNotificationRecord";
import { fetchWithAuthentication } from "../utilities/FetchUtil";

export const searchPushNotificationRecords = async (
  pageNum: number,
  startDate: string,
  endDate: string,
  setTotalPages: (newValue: number) => void,
  setTotalRecords: (newValue: number) => void,
  setLoading: (newValue: boolean) => void,
  pageSize: number = 20,
): Promise<PushNotificationRecord[]> => {
  setLoading(true);

  if (pageNum === 0) {
    setLoading(false);
    return [];
  }

  try {
    const response = await fetchWithAuthentication(
      `/notification?startDate=${startDate.slice(0,10)}&endDate=${endDate.slice(0,10)}&pageNum=${pageNum}&pageSize=${pageSize}`,
      "GET",
      null,
    );
    const data = await response.json();
    setTotalPages(data.pageTotal);
    setTotalRecords(data.recordTotal);
    return data.pushNotificationRecords || [];
  } catch (error) {
    console.error("Error searching push notification records:", error);
    return [];
  } finally {
    setLoading(false);
  }
};
